
export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    unSubscribeMessage: {
      type: String,
      default: 'Вы действительно хотите удалить навык?',
    },
  },
  computed: {
    isUserSubscribe() {
      if (this.$auth.loggedIn) {
        return this.$auth.user?.skills?.includes(this.id)
      }
      return false
    },
  },
  methods: {
    async subscribe() {
      if (this.$auth.loggedIn) {
        await this.$axios.$post('/users/add/skill', {
          product: this.id,
        })
        await this.$auth.fetchUser()
        this.$emit('subscribe')
      } else {
        this.$router.push('/login')
      }
    },
    async unSubscribe() {
      const isUnSubscribe = await this.$refs.confirmDialogue.show({
        title: 'Удалить навык',
        message: this.unSubscribeMessage,
        okButton: 'Удалить навык',
      })
      if (isUnSubscribe) {
        if (this.$auth.loggedIn) {
          await this.$axios.$post('/users/remove/skill', {
            product: this.id,
          })

          await this.$auth.fetchUser()
          this.$emit('unsubscribe')
        } else {
          this.$router.push('/login')
        }
      }
    },
  },
}
